const standardSegmentItemsData = [
	{
		"name" : "Debut",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "new-talent",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Slander Competitor",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Champion Coronation",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "new-champion",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "This Belongs To You",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "award-title",
		"oneAtATime" : true,
		"requirement" : "vacant-title",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 2,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Exposing the Past",
		"description" : null,
		"unlocked" : false,
		"silly" : true,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 1,
		"difficulty" : 3,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Anger Management",
		"description" : null,
		"unlocked" : true,
		"silly" : true,
		"maxParticipants" : 3,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "team-superstars",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Cash-In Tease",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : "contract-and-champion",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Title Destruction",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "champion",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 1,
		"difficulty" : 3,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Push-up Contest",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Singing Contest",
		"description" : null,
		"unlocked" : true,
		"silly" : true,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Slime Surprise",
		"description" : null,
		"unlocked" : true,
		"silly" : true,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Spooky Trick",
		"description" : null,
		"unlocked" : true,
		"silly" : true,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Promo Ambush",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Epic Brawl",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "previous-feuds",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 1,
		"difficulty" : 3,
		"entertainment" : 0,
		"action" : 3,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Backstage BBQ",
		"description" : null,
		"unlocked" : true,
		"silly" : true,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Smack Talk",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 1,
		"difficulty" : 3,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Legend's Praise",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 3,
		"minParticipants" : 3,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "legend",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 2,
		"difficulty" : 3,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "You're Fired",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "fire-superstar",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 2,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Title Disrespect",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "title-feud",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Demand Title Shot",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "champion",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Lost My Smile",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "vacate-title",
		"oneAtATime" : true,
		"requirement" : "champion",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 3,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Local Squash",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 0,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Masked Attacker",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Car Destruction",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 1,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Home Invasion",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 1,
		"difficulty" : 3,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Kidnapping",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Midget Impersonation",
		"description" : null,
		"unlocked" : true,
		"silly" : true,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : true,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Promo Battle",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 4,
		"minParticipants" : 2,
		"consequence" : "",
		"oneAtATime" : false,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Fight",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 4,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Team Tension",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 3,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "team-superstars",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Contract Signing",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Unlikely Partners",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Talk Show",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 3,
		"minParticipants" : 3,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Mutual Respect",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "feud-blowoff",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : true,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Moving On",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "feud-blowoff",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : true,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Heat Promo",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "heel",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Spirited Promo",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "face",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Vicious Beatdown",
		"description" : "Creates the 'Fighting the Darkness' Feud",
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "heel-turn",
		"oneAtATime" : true,
		"requirement" : "face-vs-face",
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Backstab",
		"description" : "Creates the 'Betrayal' Feud",
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 3,
		"minParticipants" : 2,
		"consequence" : "heel-turn",
		"oneAtATime" : true,
		"requirement" : "face-team-superstars",
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Beatdown Save",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 3,
		"minParticipants" : 3,
		"consequence" : "face-turn",
		"oneAtATime" : true,
		"requirement" : "face-vs-heel-past-feud",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 2,
		"entertainment" : 1,
		"action" : 2,
		"oneWayConsequence" : true,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Forgiveness",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "face-turn-and-blowoff",
		"oneAtATime" : true,
		"requirement" : "face-vs-heel",
		"chooseWinner" : false,
		"feudOnly" : true,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : true,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Defying a Villain",
		"description" : "Creates the 'Becoming Good' Feud",
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 3,
		"minParticipants" : 2,
		"consequence" : "face-turn",
		"oneAtATime" : true,
		"requirement" : "heel-team-superstars",
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Delayed Vengeance",
		"description" : "Creates the 'Vengeance' Feud",
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "heel-turn",
		"oneAtATime" : true,
		"requirement" : "face-vs-face-past-feud",
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 1,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Joining the Devil",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 3,
		"minParticipants" : 3,
		"consequence" : "heel-turn",
		"oneAtATime" : true,
		"requirement" : "face-vs-heel-past-feud",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 2,
		"entertainment" : 1,
		"action" : 2,
		"oneWayConsequence" : true,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Neutralize",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "neutral-turn",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Villainize",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "heel-turn",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Build Honor",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "face-turn",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Feud Package",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "level-1-producer",
		"chooseWinner" : false,
		"feudOnly" : true,
		"hypeBoost" : 2,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : true,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Video Package",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "level-1-producer",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : true,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Event Package",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 0,
		"minParticipants" : 0,
		"consequence" : "boost-event-hype",
		"oneAtATime" : true,
		"requirement" : "level-1-producer",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : true,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Debut Package",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "new-talent-and-level-2-producer",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : true,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Return Package",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "returning-talent-and-level-2-producer",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : true,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Career Package",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "retiring-talent-and-level-3-producer",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : true,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Day in the Life",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "level-3-producer",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 2,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : true,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Competitor Buyout",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 0,
		"minParticipants" : 0,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : "buyout-offer-accepted",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Championship Split",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "split-title",
		"oneAtATime" : true,
		"requirement" : "obsidian-champion",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "New Title Reveal",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "change-title-design",
		"oneAtATime" : true,
		"requirement" : "gold-champion",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Option C",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "vacate-title-and-create-match-contract",
		"oneAtATime" : true,
		"requirement" : "silver-champion",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Champion Package",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "champion-and-level-2-producer",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : true,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Cryptic Threat",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "create-random-feud",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "New Alliance",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 4,
		"minParticipants" : 4,
		"consequence" : "create-trio-of-heels",
		"oneAtATime" : true,
		"requirement" : "heels-vs-face-singles",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Proven Winner",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "feud-blowoff",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : true,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Best Company Brag",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 0,
		"minParticipants" : 0,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "company-of-the-year-award",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Laying Down The Law",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "suspend",
		"oneAtATime" : true,
		"requirement" : "",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Strip Champion",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "vacate-title",
		"oneAtATime" : true,
		"requirement" : "champion",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Dangerous Attack",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "loser-unavailable",
		"oneAtATime" : true,
		"requirement" : "",
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 0,
		"difficulty" : 2,
		"entertainment" : 1,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "New Partner",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "remove-tag-team-and-create-tag-team",
		"oneAtATime" : true,
		"requirement" : "injured-partner-and-singles-superstar",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "One Last Run",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "create-retirement-feud",
		"oneAtATime" : true,
		"requirement" : "retiring",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Better Together",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "create-tag-team-and-blowoff",
		"oneAtATime" : true,
		"requirement" : "singles-superstars",
		"chooseWinner" : false,
		"feudOnly" : true,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Retirement Announcement",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "retire",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Police Arrest",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "suspend",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "I Quit",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "make-unavailable",
		"oneAtATime" : true,
		"requirement" : "",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "New Gimmick Package",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "new-gimmick-and-level-1-producer",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : true,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "New Heel Promo",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "shocking-heel-turn",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 2,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "New Babyface Promo",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "shocking-face-turn",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 2,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Retirement Gloat",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "not-done-yet-potential-feud",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Injury Gloat",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "inflicted-injury",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Trophy Destruction",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "award-winner",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Best Wrestler Promo",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "wrestler-of-the-year-award",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "I'm The Face",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "face-of-the-company",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Legendary Beatdown",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "legend-and-heel",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 2,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Legendary Endorsement",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "legend-and-over-superstar",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Losing Streak Promo",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "losing-streak",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Retirement Ceremony",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "retirement",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Spouse Affair",
		"description" : null,
		"unlocked" : true,
		"silly" : true,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "This Is My Life",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 2,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Siblings Parody",
		"description" : null,
		"unlocked" : true,
		"silly" : true,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Bodybuilding Contest",
		"description" : null,
		"unlocked" : true,
		"silly" : true,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Backstage Attack",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Entrance Parody",
		"description" : null,
		"unlocked" : false,
		"silly" : true,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Recap Package",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 0,
		"minParticipants" : 0,
		"consequence" : "boost-popularity",
		"oneAtATime" : true,
		"requirement" : "level-1-producer",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : true,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Main Event Package",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 0,
		"minParticipants" : 0,
		"consequence" : "boost-main-event-hype",
		"oneAtATime" : true,
		"requirement" : "level-1-producer",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : true,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Backstage Interview",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Stunt Dive",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 3,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : true,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Car Explosion",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 3,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : true,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Dummy Wrestling",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 3,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : true,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Timely Rescue",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 3,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : true,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Helicopter Raid",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 3,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : true,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Ring Invasion",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 3,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : true,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Love Making",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 3,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : true,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Celebrity Beatdown",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 3,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : true,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Anti-Company Rant",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 3,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : true,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Hosedown",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 3,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : true,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Handicap Beatdown",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 5,
		"minParticipants" : 3,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Rip Off Mask",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "masked-talent",
		"chooseWinner" : false,
		"feudOnly" : true,
		"hypeBoost" : 2,
		"popularityBoost" : 0,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Kicked Out",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "remove-faction-members",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : true
	},
	{
		"name" : "Time To Leave",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "remove-faction-members",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : true
	},
	{
		"name" : "New Blood",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "add-faction-members",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : true
	},
	{
		"name" : "Our Leader",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "add-faction-leader",
		"oneAtATime" : true,
		"requirement" : "no-faction-leader",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : true
	},
	{
		"name" : "New Leadership",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "change-faction-leader",
		"oneAtATime" : true,
		"requirement" : "faction-leader-present",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : true
	},
	{
		"name" : "No Leadership",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "remove-faction-leadership",
		"oneAtATime" : true,
		"requirement" : "faction-leader-present",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : true
	},
	{
		"name" : "Usurped",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "kick-out-faction-leader-and-change-leader",
		"oneAtATime" : true,
		"requirement" : "faction-leader-present",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : true
	},
	{
		"name" : "Switching Sides",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "leave-faction-and-join-other-faction",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : true
	},
	{
		"name" : "Joining Forces",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "merge-factions",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : true
	},
	{
		"name" : "Internal Division",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "split-faction",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : true
	},
	{
		"name" : "Our End",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "disband-faction",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : true
	},
	{
		"name" : "New Power",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 0,
		"minParticipants" : 0,
		"consequence" : "create-faction",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : true
	},
	{
		"name" : "Manager Promo",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "boost-managed-talent",
		"oneAtATime" : true,
		"requirement" : "manager",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Dismiss Manager",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "remove-manager",
		"oneAtATime" : true,
		"requirement" : "manager-present",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : false
	},
	{
		"name" : "Reveal Manager",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "add-manager",
		"oneAtATime" : true,
		"requirement" : "no-manager",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : false
	},
	{
		"name" : "Client Betrayal",
		"description" : "Creates the 'Former Manager' Feud",
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "remove-managed-talent",
		"oneAtATime" : true,
		"requirement" : "manager",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 2,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : false
	},
	{
		"name" : "Brand Signing",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 0,
		"minParticipants" : 0,
		"consequence" : "draft-talent-to-brand",
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : false
	},
	{
		"name" : "Brand Invasion",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 8,
		"minParticipants" : 3,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "other-brand-talent",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 3,
		"difficulty" : 2,
		"entertainment" : 1,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : false
	},
	{
		"name" : "Surprise Return",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "returning-talent",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Debut Attack",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "new-talent",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Retirement Fakeout",
		"description" : "Creates the 'I Can Still Go' Feud",
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "heel-turn",
		"oneAtATime" : true,
		"requirement" : "retiring",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 2,
		"oneWayConsequence" : true,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Return Attack",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "returning-talent",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Title Unification",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "unify-titles",
		"oneAtATime" : true,
		"requirement" : "double-champion",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Righteous Beatdown",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : "face-turn",
		"oneAtATime" : true,
		"requirement" : "heel-vs-heel",
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Face Reveal",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : "remove-mask",
		"oneAtATime" : true,
		"requirement" : "masked-talent",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "New Association",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 3,
		"minParticipants" : 2,
		"consequence" : "create-team",
		"oneAtATime" : true,
		"requirement" : "singles-superstars",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Cutting Ties",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 3,
		"minParticipants" : 2,
		"consequence" : "disband-team",
		"oneAtATime" : true,
		"requirement" : "team-superstars",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Catchphrase Showdown",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "over-talent",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 2,
		"difficulty" : 3,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Indifferent Promo",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "neutral",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Debut Promo",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "new-talent",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 2,
		"difficulty" : 1,
		"entertainment" : 3,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Desecrate Grave",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Spouse Attack",
		"description" : null,
		"unlocked" : false,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 1,
		"difficulty" : 2,
		"entertainment" : 2,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Interview Attack",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 0,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "After Match Save",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 0,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "After Match Attack",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 0,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Surprise Attack",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 0,
		"action" : 2,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Tense Pull-Apart",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Standing Tall",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Forced To Retreat",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Fight Tease",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 0,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Staredown",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Solo Feud Promo",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : false,
		"requirement" : "feud-present",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Split Interview",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Off-Camera Assault",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 2,
		"popularityBoost" : 0,
		"difficulty" : 2,
		"entertainment" : 1,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "Backstage Confrontation",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 2,
		"minParticipants" : 2,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : null,
		"chooseWinner" : true,
		"feudOnly" : false,
		"hypeBoost" : 1,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 1,
		"action" : 1,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	},
	{
		"name" : "TGI Victory Boast",
		"description" : null,
		"unlocked" : true,
		"silly" : false,
		"maxParticipants" : 1,
		"minParticipants" : 1,
		"consequence" : null,
		"oneAtATime" : true,
		"requirement" : "the-grand-invitational-winner",
		"chooseWinner" : false,
		"feudOnly" : false,
		"hypeBoost" : 0,
		"popularityBoost" : 1,
		"difficulty" : 1,
		"entertainment" : 2,
		"action" : 0,
		"oneWayConsequence" : false,
		"productionSegment" : false,
		"startTexts" : null,
		"actionTexts" : null,
		"custom" : false,
		"temporary" : false,
		"saveToCommunity" : false,
		"text" : null,
		"special" : false,
		"used" : false,
		"monthsToReuse" : 36,
		"factionSegment" : null
	}
];

export {standardSegmentItemsData}
